'use strict';

function throwError(message, params) {
    var error = new Error(message);
    for (var key in params) {
        error[key] = params[key];
    }
    throw error;
}

module.exports = throwError;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ethers/utils/throw-error.js
// module id = 570
// module chunks = 0